import React from "react";
import Select from "react-select";

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "35px", // your desired consistent height
    height: "35px",
    fontSize: "14px",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "35px",
  }),
  valueContainer: (base) => ({
    ...base,
    height: "35px",
    padding: "0 8px",
  }),
};

const CustomSelect = ({ styles: overrideStyles = {}, ...props }) => {
  const mergedStyles = {
    ...customStyles,
    ...overrideStyles,
  };
  return <Select styles={mergedStyles} {...props} />;
};

export default CustomSelect;
